export const IgnoredKeys = [
  "MediaTrackNext",
  "MediaTrackPrevious",
  "MediaPlayPause",
  "AudioVolumeUp",
  "AudioVolumeDown",
  "AudioVolumeMute",
  "Home",
  "End",
];
